// extracted by mini-css-extract-plugin
module.exports = {"featureContainer":"Features_featureContainer__petpU","feature":"Features_feature__2am5P","featureRight":"Features_featureRight__3_S5U"};